<template>
    <div style="margin-top: 5px;">
        <el-descriptions :title="$t('lang.详细信息')" :column="2" border>
            <el-descriptions-item :label="$t('lang.试验方法')">
                {{ dic[detailData.main.shiYanFangFa] }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('lang.检测对象')">
                {{ dic[detailData.main.jianCeDuiXiang] }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('lang.试验类型')">
                {{ dic[detailData.main.shiYanLeiXing] }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('lang.试验编号')">
                {{ detailData.main.shiYanBianHao }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('lang.开始时间')">
                {{ detailData.main.startTime }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('lang.结束时间')">
                {{ detailData.main.stopTime }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('lang.运行时长')">
                {{ detailData.main.yunXingShiChang }}
            </el-descriptions-item>
            <el-descriptions-item :label="$t('lang.空白试验结果')" :contentStyle="{ color: 'red' }">
                {{ detailData.main.v_ShuiNi_KongBai }}mL
            </el-descriptions-item>
            <el-descriptions-item :label="$t('lang.氯化物试验结果')" :contentStyle="{ color: 'red' }">
                {{ detailData.main.v_ShuiNi_LvHuaWu }}mL
            </el-descriptions-item>
            <el-descriptions-item :label="$t('lang.硝酸银浓度')" :contentStyle="{ color: 'red' }">
                {{ detailData.main.xiaoSuanYinNongDu }}mol/L
            </el-descriptions-item>
            <el-descriptions-item :label="$t('lang.氯化物质量')" :contentStyle="{ color: 'red' }">
                {{ detailData.main.lvHuaWuZhiLiang }}g
            </el-descriptions-item>
            <el-descriptions-item :label="$t('lang.质量百分比')" :contentStyle="{ color: 'red' }">
                {{ detailData.main.zhiLiangBaiFenBi.toFixed(5) }}%
            </el-descriptions-item>
        </el-descriptions>
    </div>
</template>

<script>
import dic from "../../../assets/common/dic/dic.js";

export default {
    props: ["detailData"],
    data() {
        return {
            dic: dic
        };

    },
    methods: {

    },

    mounted() {

    }

};
</script>

<style></style>